import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Text, spacing } from '@retailer-platform/shared-components'
import { SelectableCell } from 'legacy/components/Forms'
import ContentExampleHero from 'assets/content-example-hero.svg'
import ContentExampleIntroSheet from 'assets/content-example-intro-sheet.svg'
import ContentExampleSecondary from 'assets/content-example-secondary.svg'
import { useDashMessages } from 'intl/intl.hooks'
import { bannerTypes } from 'domains/banners/constants/banner.constants'
import { isHeroBanner, isSecondaryBanner, isFlyout } from 'domains/banners/utils/bannerUtils'
import { type PlacementTypeEnum } from 'domains/banners/api'

const selectorContainer = css({
  display: 'flex',
  justifyContent: 'space-between',
})

const cardStyles = css({
  padding: '13px',
})

const textStyles = css({
  margin: 0,
})

const imageStyles = css({
  display: 'block',
  marginBottom: spacing.X16,
  width: '100%',
})

const cellStyles = {
  height: '350px',
  margin: '0',
}

export interface BannerCreateTypeSelectorProps {
  onSelectBanner: (value: PlacementTypeEnum) => void
  bannerType: PlacementTypeEnum
}

export const BannerCreateTypeSelector: FunctionComponent<BannerCreateTypeSelectorProps> = ({
  onSelectBanner,
  bannerType,
}) => {
  const messages = useDashMessages({
    heroBannerTitle: 'bannersDomain.banners.page.create.selector.heroBanner.title',
    heroBannerDescription: 'bannersDomain.banners.page.create.selector.heroBanner.description',
    secondaryBannerTitle: 'bannersDomain.banners.page.create.selector.secondaryBanner.title',
    secondaryBannerDescription:
      'bannersDomain.banners.page.create.selector.secondaryBanner.description',
    flyoutTitle: 'bannersDomain.banners.page.create.selector.flyout.title',
    flyoutDescription: 'bannersDomain.banners.page.create.selector.flyout.description',
  })

  return (
    <div css={selectorContainer}>
      <SelectableCell
        containerProps={cellStyles}
        isSelected={isHeroBanner(bannerType)}
        onChange={() => onSelectBanner(bannerTypes.HERO_BANNER)}
        title={messages.heroBannerTitle}
      >
        <div css={cardStyles}>
          <img src={ContentExampleHero} css={imageStyles} />
          <Text styles={textStyles}>{messages.heroBannerDescription}</Text>
        </div>
      </SelectableCell>
      <SelectableCell
        containerProps={cellStyles}
        isSelected={isFlyout(bannerType)}
        onChange={() => onSelectBanner(bannerTypes.FLYOUT)}
        title={messages.flyoutTitle}
      >
        <div css={cardStyles}>
          <img src={ContentExampleIntroSheet} css={imageStyles} />
          <Text styles={textStyles}>{messages.flyoutDescription}</Text>
        </div>
      </SelectableCell>
      <SelectableCell
        containerProps={cellStyles}
        isSelected={isSecondaryBanner(bannerType)}
        onChange={() => onSelectBanner(bannerTypes.SECONDARY_BANNER)}
        title={messages.secondaryBannerTitle}
      >
        <div css={cardStyles}>
          <img src={ContentExampleSecondary} css={imageStyles} />
          <Text styles={textStyles}>{messages.secondaryBannerDescription}</Text>
        </div>
      </SelectableCell>
    </div>
  )
}
